import io from "socket.io-client";

export const socket = io('https://taixiu.xanhchin.io');